import React from 'react';

interface SubscriptionStatusCheckboxProps {
  altText: string;
  className: string;
  displayText: string;
  imgSrc: string;
}

const SubscriptionStatusCheckbox = ({
  altText,
  className,
  displayText,
  imgSrc,
}: SubscriptionStatusCheckboxProps): JSX.Element => {
  return (
    <>
      <img src={imgSrc} alt={altText} />
      <div className={className}>{displayText}</div>
    </>
  );
};

export default SubscriptionStatusCheckbox;
